export enum BiogenFunction {
  Commercial = 'Commercial',
  Medical = 'Medical',
  MarketAccess = 'Market Access',
}

export enum VeevaVaultBiogenFunction {
  Commercial = 'Sales',
  Medical = 'Medical',
  MarketAccess = 'Market Access',
}

export enum Specialities {
  childNeurology = 'Child Neurology',
  dermatology = 'Dermatology',
  gastroenterology = 'Gastroenterology',
  generalPractice = 'General Practice',
  generalSurgery = 'General Surgery',
  geriatricsGerontology = 'Geriatrics/Gerontology',
  hospitalPharmacy = 'Hospital Pharmacy',
  internalMedicine = 'Internal Medicine',
  neurology = 'Neurology',
  ophthalmology = 'Ophthalmology',
  other = 'Other',
  pediatrics = 'Pediatrics',
  physicalMedicineRehabilitation = 'Physical Medicine & Rehabilitation',
  physicalTherapy = 'Physical Therapy',
  psychiatry = 'Psychiatry',
  radiology = 'Radiology',
  rheumatology = 'Rheumatology',
}

export enum CustomerTypes {
  advocacyGroups = 'Advocacy groups',
  caregiver = 'Caregiver',
  insurances = 'Insurances',
  internalAudience = 'Internal Audience',
  KMEs = 'KMEs',
  nurses = 'Nurses',
  other = 'Other',
  patient = 'Patient',
  patientsCaregivers = 'Patients/Caregivers',
  payers = 'Payers',
  pharmacists = 'Pharmacists',
  physiciansPrimaryCare = 'Physicians - primary care',
  physiciansSpecialists = 'Physicians - specialists',
  physiotherapists = 'Physiotherapists',
  policyMakers = 'Policy Makers',
  public = 'Public',
}

export enum Channel {
  approvedEmail = 'Approved eMail',
  broadcastEmail = 'Broadcast eMail',
  f2fEvent = 'F2F Event',
  f2fMeeting = 'Face to Face',
  hybridEvent = 'Hybrid Event',
  oneToOne = '1:1',
  oneToOneDropMaterial = '1:1 with Drop Material',
  oneToOneIVA = '1:1 with IVA',
  oneToOneKeyMessage = '1:1 with Key Message',
  telephone = 'Telephone',
  virtualEvent = 'Virtual Event',
  virtualMeeting = 'Virtual',
  webLogIn = 'Web LogIn',
  webNoLogIn = 'Web No LogIn',
  group = 'Group',
}

export enum ChannelsDetail {
  privateEmail = 'Detail privateEmail',
  approveEmail = 'Detail approveEmail',
  broadcastEmail = 'Detail broadcastEmail',
  faceToFace = 'Detail faceToFace',
  journalAds = 'Detail journalAds',
  other = 'Detail Other',
  postalMail = 'Detail postalMail',
  serviceCall = 'Detail serviceCall',
  socialMedia = 'Detail socialMedia',
  telephone = 'Detail Telephone',
  thirdPartyBanner = 'Detail thirdPartyBanner',
  thirdPartyElearning = 'Detail thirdPartyElearning',
  thirdPartyEmail = 'Detail thirdPartyEmail',
  thirdPartyWeb = 'Detail thirdPartyWeb',
  virtualEvents = 'Detail virtualEvents',
  web = 'Detail Web',
}

export enum CepSteps {
  configurationStep = 'configurationStep',
  goalStep = 'goalStep',
  tacticsStep = 'tacticsStep',
  targetListStep = 'targetListStep',
  miViewPreviewStep = 'miViewPreviewStep',
}

export enum ReachMetric {
  openRate = 'Open rate',
  ctaClickRate = 'CTA click rate',
  registrationRate = 'Registration rate',
  uniqueVisits = 'Unique visits',
}

export enum EngagementMetric {
  openRate = 'Open rate',
  ctaClickRate = 'CTA click rate',
  attendanceRate = 'Attendance rate',
  actionCompleted = 'Action completed',
}

export enum TacticMode {
  form = 'form',
  list = 'list',
}

export enum TargetListMode {
  select = 'select',
  upload = 'upload',
  dynamic = 'dynamic',
}

export enum CepStatus {
  ONGOING = 'Ongoing',
  FEEDBACK = 'Feedback',
  APPROVED = 'Approved',
  DRAFT = 'Draft',
  DELETED = 'Deleted',
  CANCELLED = 'Cancelled',
}

export enum CepStatusActions{
  DELETE = 'Delete',
  CANCEL = 'Cancel',
  RESTORE = 'Restore',
}

export enum CiStatus {
  DRAFT = 'Draft',
  ACTIVE = 'Active',
  DELETED = 'Deleted',
}

export enum TacticStatus {
  APPROVED = 'Approved',
  DELETED = 'Deleted',
  OBSOLETE = 'Obsolete',
  CANCELLED = 'Cancelled',
  DRAFT = 'Draft',
  EMPTY = '', // HANDLING OLD TACTICS WITH EMPTY STATUS (OLD DRAFT STATUS)
}

export enum VeevaSyncStatus {
  PENDING = 'Pending',
  PENDING_DELETION = 'Pending Deletion',
  SYNC = 'Sync',
  ERROR = 'Error',
}

export enum TacticTabsType {
  EMAIL = 'Email',
  EVENT = 'Event',
  INTERACTION = 'Interaction',
  WEB = 'Web',
}

export enum KeyMessageType {
  keyMessage = 'Key Message',
  medicalStrategy = 'Medical Strategy',
  discussionTopic = 'Discussion Topic',
}

export enum TacticDisplayType {
  kanban = 'kanban',
  list = 'list',
}

export enum BooleanOptionsValue {
  true = 'Yes',
  false = 'No',
}

export enum AlertMessageType {
  VeevaFatalErrorAlert = 'veevaFatalErrorAlert',
  MayaAlert = 'mayaAlert',
}

export enum TacticSuffix {
  click = '- CLICK',
  open = '- OPEN',
}

export enum VaultDocumentStatuses {
  AmendAndResubmit = 'Amend and Resubmit',
  AmendAndReAttest = 'Amend & Re-Attest',
  Approved = 'Approved',
  ApprovedForProduction = 'Approved for Production',
  ApprovedWithChanges = 'Approved with Changes',
  AwaitingResponseFromHealthAuthority = 'Awaiting Response from Health Authority',
  Draft = 'Draft',
  InCoordinatorReview = 'In Coordinator Review',
  InFrancePreReleaseCheck = 'In France Pre-Release Check',
  InReview = 'In Review',
  InCertification = 'In Certification',
  PendingCertification = 'Pending Certification',
  PendingAttestation = 'Pending Attestation',
  ReadyForApproved = 'Ready for Approved',
  ReadyForAttestation = 'Ready for Attestation',
  ReadyForReview = 'Ready for Review',
  Staged = 'Staged',
}

